<template>
    <div class="page">
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br /> {{ userStore.user.address }}
            <br /> {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}

            
        </p>
        <p>
            <br /> {{ creditor.creditor_name }}
            <br />
            <template v-if="creditor.address">
                {{ creditor.address }}
            </template>
            <template v-else>
                {{ creditor.address_line }}<br /> {{ creditor.city }}, {{ creditor.state }} {{ creditor.zipcode }}
            </template>
            <br />
            <br /> Date: {{ date }}
        </p>
        <p> To Whom It May Concern: </p>
        <p class="letter-content">
            This letter is in reference to {{ lodash.join(lodash.map(accounts, 'account_number'), ', ') }} that your company is currently reporting to Equifax, Experian and TransUnion under my name. The account is being reported to have a derogatory rating which is very troubling to me! I am concerned about my credit because I was recently denied a loan and my existing credit accounts have increased my current interest rates. This negative rating has caused me some serious financial distress and will continue to cause me financial and emotional distress until it is resolved.
        </p>
        <p class="letter-content">
            In researching my legal rights, I have found several items that I understand I am entitled to under these circumstances. In order to rectify this situation and ensure my rights have not been violated in any way under the various consumer protection laws, I must hereby formally demand an information request!
        </p>
        <p class="letter-content">
            I understand that The Fair Credit Billing Act requires creditors to bill correctly, that each statement be sent to the correct address, that you not ignore change of address requests, and that you facilitate disputed charges in a manner prescribed by law. The Act also stipulates that you provide lawfully requested information concerning my account upon request and in a timely manner. For that reason, I request that you please forward a notarized statement on your letterhead which will attest to your compliance to the FCBA generally and to my account specifically throughout the period I have been a customer.
        </p>
        I request, under the FCBA, that you include all of the following for my reference and research into this matter:
        <ol>
            <li class="letter-content">
                A detailed and itemized statement of ALL activity to this account, including the contract I must have allegedly signed to bind me to this debt.
            </li>
            <li class="letter-content">
                The photo identification I must have provided at the time of starting services with you in order for you to assure that this was not an attempt of someone else to commit a fraud against me (you do take these precautions correct?).
            </li>
            <li class="letter-content"> A full file disclosure. </li>
            <li class="letter-content">
                An itemized statement breaking down the balance you claim I owe.
            </li>
            <li class="letter-content">
                Any other documentation you must have in order to truthfully make a notarized statement on your letterhead, attesting to your compliance of the FCBA.
            </li>
        </ol>
        <p class="letter-content">
            If you cannot provide this requested correspondence, then please delete the negative marks you have reported to the three consumer reporting agencies about me within the timely manner prescribed by law. Your prompt attention to this matter will be greatly appreciated.
        </p>
        <p>
            Sincerely,
            <br />
            <br /> {{ userStore.user.firstname }} {{ userStore.user.lastname }}
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    import lodash from 'lodash'
    export default {
        props: {
            accounts: {
                type: [Array, Object]
            },
            creditor: {
                type: [Array, Object]
            }
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                userStore: useUserStore(),
                lodash: lodash
            };
        }
    };
</script>